module.exports = __webpack_public_path__ + "img/padlock-locked.83349303.svg";